import _ from 'lodash';

// currencyStringToInt converts a string value for money into an int.
// Returns an integer or NaN.
export const currencyStringToInt = (val) => {
  if (!_.isString(val)) return NaN;

  // Support the standard xxx.yy format only for now.
  const formatterUSD = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  // $ or any other non-number prefix or suffix.
  const cleanVal = val.replace(/[^\d.-]/g, '');

  // Get a value like 123.40 or -2.00
  const cleanStr = formatterUSD.format(cleanVal);

  // Remove the , and . to get cents.
  const valInt = Number(cleanStr.replace(',', '').replace('.', ''));
  return valInt;
};
